import "./document-view.css";

const defaultProps = {
  document: "path_to_doc",
};

export default function DocumentView(props = defaultProps) {
  return <iframe className="document-view" src={props.document} frameborder="0"></iframe>;
}
